<div (uiClickOutside)="closeModal()">
    <div class="ui-folder-tree-modal-header">
        <ui-folder-tree-breadcrumbs [folder]="state.selectedFolder">
        </ui-folder-tree-breadcrumbs>
        <button mat-dialog-close
                mat-icon-button
                type="button"
                class="ui-folder-tree-modal-header-close-btn"
                tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-divider></mat-divider>

    <ui-folder-tree [context]="'switch'"
                    [state]="state"
                    (selectedFolder)="switchFolder()">
    </ui-folder-tree>

    <mat-divider></mat-divider>

    <ng-container *uiModernContext>
        <mat-dialog-actions class="ui-folder-tree-modal-actions">
            <div class="ui-folder-legend">
                <div [matTooltip]="'upsert_folder_manually_provisioned_robots' | translate"
                     class="ui-folder-legend-item">
                    <mat-icon class="ui-folder-icon-classic">folder_open</mat-icon>
                    <span> – {{'folder_picker_tooltip_Classic' | translate}}</span>
                </div>
                <div [matTooltip]="'upsert_folder_automatically_provisioned_robots' | translate"
                     class="ui-folder-legend-item">
                    <mat-icon class="ui-folder-icon-modern">folder_open</mat-icon>
                    <span> – {{'folder_picker_tooltip_Modern' | translate}}</span>
                </div>
            </div>
        </mat-dialog-actions>
    </ng-container>
</div>
